import axios, { AxiosRequestConfig } from "axios"
import { getApiUrl } from "backend-routes"
import { TokenKeys } from "etl/types"

export const awAxiosInstance = axios.create({
	baseURL: getApiUrl().awUrl,
})

/**
 * Add the token to request if found it
 */
const addTokenToRequest = async (config: any) => {
	const token = localStorage.getItem(TokenKeys.AW_TOKEN)
	if (token) {
		if (token !== "" && token !== null && config.headers) {
			config.headers["Authorization"] = `Bearer ${token}`
		}
	}
	return config
}

awAxiosInstance.interceptors.request.use((config) => addTokenToRequest(config))

export interface AxiosParams {
	url: string
	method: AxiosRequestConfig["method"]
	data?: AxiosRequestConfig["data"]
	params?: AxiosRequestConfig["params"]
	headers?: AxiosRequestConfig["headers"]
	responseType?: AxiosRequestConfig["responseType"]
}

export const axiosBaseQuery = async ({ url, method, data, params, headers, responseType }: AxiosParams) => {
	return await awAxiosInstance({
		url,
		method,
		data,
		params,
		headers,
		responseType,
	})
}
